import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import ModalHelp from '../../../components/ModalHelp';
import { useNavigate } from 'react-router-dom';

interface ConfirmarEnvioTermoBancaModalProps {
    show: boolean;
    handleClose: () => void;
    handleConfirm: () => void;
    quantidade: number;
    processoId: string;
    bancaId: string;
}

const ConfirmarEnvioTermoBancaModal: React.FC<ConfirmarEnvioTermoBancaModalProps> = ({ 
    show, 
    handleClose, 
    handleConfirm, 
    quantidade,
    processoId,
    bancaId
}) => {
    const navigate = useNavigate();

    const handleNavigateToCandidatos = () => {
        handleClose();
        navigate(`/processos/${processoId}/bancas/${bancaId}/candidatos`);
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirmar Envio de Termo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ModalHelp text="Envia os termos de heteroidentificação para os candidatos da banca. Evite reenviar para candidatos que já receberam." />
                <Alert variant="info">
                    Verifique se é necessário aguardar publicação no DOE para enviar esses termos.
                </Alert>
                <Alert variant="warning">
                    Atente-se para não reenviar termos para candidatos que já os receberam, o que pode confundi-los.
                </Alert>
                <p>
                    Deseja enviar o termo para <strong>{quantidade}</strong> candidato(s)?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancelar
                </Button>
                <Button variant="info" onClick={handleNavigateToCandidatos}>
                    Envio individualizado
                </Button>
                <Button variant="success" onClick={handleConfirm}>
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmarEnvioTermoBancaModal;
